<template>
	<div class="button-line">
		<div>
			<Button
				secondary
				smaller
				icon="caret-right"
				text="Passenden Job finden"
				href="/jobfinden"
			/>
		</div>
		<div>{{ middleText }}</div>
		<div>
			<Button
				icon="caret-right"
				text="Passende Mitarbeiter finden"
				href="/kunde/eintragung"
			/>
		</div>
	</div>
</template>

<script>
import Button from "@/vue/common/Button.vue";

export default {
	components: {Button},

	props: {
		middleText: {
			type: String,
			required: true
		},
	},
}
</script>
